import { render, staticRenderFns } from "./CtaYellow.vue?vue&type=template&id=b9274f20"
import script from "./CtaYellow.vue?vue&type=script&lang=js"
export * from "./CtaYellow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports